import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { BaseApiTemplateService, Core2Config } from "../../shared";

//  /core2/tnt/dm/erp/gen-doc/order-received-outstanding-qty/backoffice-ep/{guid}

@Injectable({ providedIn: "root" })
export class GendocOrderReceivedOutstandingService extends BaseApiTemplateService<any> {

  constructor(http: HttpClient) {
    super();
    this.endpoint_path = Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX + Core2Config.GENERIC_PREFIX + "order-received-outstanding-qty/backoffice-ep";
    this.httpClient = http;
  }
}
